import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  GET_NOTIFICATIONS,
  ADD_NOTIFICATIONS,
  NO_MORE_NOTIFICATIONS,
  NEW_NOTIFICATION,
  CHANGE_SHOP_STATUS,
  UPLOAD_DP,
  SELLER_IS_BLOCKED,
  CLEAR_AUTH_MSG,
} from "../actions/Types";

const initialState = {
  token: null,
  isAuthenticated: null,
  seller: null,
  msg: null,
  notifications: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        seller: action.payload.data,
        token: action.payload.token,
        isAuthenticated: true,
        msg: action.payload.msg,
      };
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case CLEAR_AUTH_MSG:
      return {
        ...state,
        token: null,
        seller: null,
        isAuthenticated: false,
        msg: "Logout",
        notifications: []
      };
    case SELLER_IS_BLOCKED:
      return {
        ...state,
        token: null,
        seller: null,
        isAuthenticated: false,
        msg: "Seller is blocked",
      };
    case NEW_NOTIFICATION:
      return {
        ...state,
        newNotification: action.payload,
      };
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };
    case ADD_NOTIFICATIONS:
      return {
        ...state,
        notifications: [...state.notifications, ...action.payload],
        msg: "",
      };
    case NO_MORE_NOTIFICATIONS:
      return {
        ...state,
        msg: "No More Notifications",
      };
    case UPLOAD_DP:
      return {
        ...state,
        seller: { ...state.seller, image: action.payload },
      };
    case CHANGE_SHOP_STATUS:
      return {
        ...state,
        seller: {
          ...state.seller,
          open: action.payload,
        },
      };
    default:
      return state;
  }
}
